import "core-js/modules/es.array.concat.js";
import { getReq, postReq, putReq } from './axios';
import { allContactsParams } from './models';
var BASE_URL = "".concat(apiUrl, "/contact-person");
export var getContactsList = function getContactsList(params) {
  return getReq(BASE_URL, {
    params: allContactsParams(params)
  });
};
export var createContact = function createContact(body) {
  return postReq(BASE_URL, body);
};
export var updateContact = function updateContact(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};